import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertService } from 'src/app/shared/services/alert.service';
import { PagesService } from '../../pages.service';

@Component({
  selector: 'app-add-new-xpcn',
  templateUrl: './add-new-xpcn.component.html',
  styleUrls: ['./add-new-xpcn.component.scss']
})
export class AddNewXPCNComponent implements OnInit {
 public popoverTitle: string = 'Confirm Add XPCN';
  public popoverMessage: string = 'Are you sure you want to Add XPCN ?';
  xpcnDetails: any[] = []
  isXPCNAdded: boolean = false
  canXPCNAdded: boolean = true
  showErrorMessage: boolean = false
  cancelClicked: any;
  lclOrderXPCNIndentingInfo: any;
  customerId: any = null
  xpcnType: string = "Forward"
  customerXPCNSeriesMode: string
  allotedLRNumberDetails: { showInputForAllotedXPCNNumber, allotedXPCNNumber: string, autoAllocateXPCNNumber: boolean, availableXPCNAllotedSeries: any[] } = { showInputForAllotedXPCNNumber: false, allotedXPCNNumber: null, autoAllocateXPCNNumber: false, availableXPCNAllotedSeries: [] }

  constructor(public alertService: AlertService, public dialogRef: MatDialogRef<AddNewXPCNComponent>,
    @Inject(MAT_DIALOG_DATA) public bookingId: any, public _pageService: PagesService) {

    dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    this.getXPCNDetails();
  }

  getXPCNDetails() {
    if (this.bookingId != null) {
      this._pageService.getBookingXPCNDetailsCore(this.bookingId).subscribe(response => {
        if (response['Success']) {
          let data = response['Data'];
          this.customerId = data["CustomerId"]
          this.customerXPCNSeriesMode = data["CustomerXPCNSeriesMode"]
          this.xpcnDetails = data["LCLXPCNDetails"]
          this.lclOrderXPCNIndentingInfo = data["LCLOrderXPCNIndentingInfo"]

          this.manageUIBasedOnCustomerXPCNSeriesMode(this.customerXPCNSeriesMode)
        }
      })
    }
  }


  manageUIBasedOnCustomerXPCNSeriesMode(customerXPCNSeriesMode: string) {
    if (customerXPCNSeriesMode == "Custom") {
      this.allotedLRNumberDetails.showInputForAllotedXPCNNumber = true
    }
  }

  addLCLOrderAndXPCN() {
    if (this.bookingId != null) {
      this.lclOrderXPCNIndentingInfo["XPCNType"] = this.xpcnType

      if (this.customerXPCNSeriesMode == "Custom" && this.allotedLRNumberDetails.allotedXPCNNumber == null) {
        this.alertService.createAlert("Please enter alloted XPCN Number", 2)
        return
      }

      this.lclOrderXPCNIndentingInfo["CustomerAllotedXPCNNumber"] = this.allotedLRNumberDetails.allotedXPCNNumber

      this._pageService.createLCLOrderAndXPCN(this.lclOrderXPCNIndentingInfo).subscribe(res => {
        if (res['Success']) {
          this.isXPCNAdded = true

          if (!this.allotedLRNumberDetails.autoAllocateXPCNNumber) {  this.allotedLRNumberDetails.allotedXPCNNumber = null }
          else this.manageUnusedXPCNSeries(false)
           
          this.getXPCNDetails()
        }
        else this.manageUnusedXPCNSeries(true)
      })
    }
    else {
      this.alertService.createAlert("Something went wrong", 0)
    }
  }

  close() {
    this.dialogRef.close({ isXpcnAdded: this.isXPCNAdded })
  }

  setXPCNSeriesAllocateMode() {
    this.allotedLRNumberDetails.autoAllocateXPCNNumber = !this.allotedLRNumberDetails.autoAllocateXPCNNumber;

    if (this.allotedLRNumberDetails.autoAllocateXPCNNumber) {
      this.getUnusedXPCNSeriesOfCustomer()
    }
    else this.allotedLRNumberDetails.allotedXPCNNumber = null

  }

  manageUnusedXPCNSeries(areSeriesExpired : boolean) {
    if(areSeriesExpired) this.allotedLRNumberDetails.availableXPCNAllotedSeries = []

    const index = this.allotedLRNumberDetails.availableXPCNAllotedSeries.findIndex(item => item.AvailableXPCN === this.allotedLRNumberDetails.allotedXPCNNumber);

    if (index !== -1) {
      this.allotedLRNumberDetails.availableXPCNAllotedSeries.splice(index, 1); // removes the element at that index
      if (this.allotedLRNumberDetails.availableXPCNAllotedSeries.length > 0) {
        this.allotedLRNumberDetails.allotedXPCNNumber = this.allotedLRNumberDetails.availableXPCNAllotedSeries[0]["AvailableXPCN"]
      }
      else {
        this.getUnusedXPCNSeriesOfCustomer()
      }
    }
    else this.getUnusedXPCNSeriesOfCustomer()
  }

  getUnusedXPCNSeriesOfCustomer() {
    this._pageService.getUnusedXPCNSeriesOfCustomer(this.customerId).subscribe(response => {
      if (response) {
        if (response["Success"]) {
          this.allotedLRNumberDetails.availableXPCNAllotedSeries = response["Data"]

          if (this.allotedLRNumberDetails.availableXPCNAllotedSeries.length > 0 && this.allotedLRNumberDetails.autoAllocateXPCNNumber) {
            this.allotedLRNumberDetails.allotedXPCNNumber = this.allotedLRNumberDetails.availableXPCNAllotedSeries[0]["AvailableXPCN"]
          }
        }
      }
    })
  }
}
